"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockUser = exports.mockUsers = exports.mockCorrectUsers = exports.showPaginationList = void 0;
exports.showPaginationList = {
    total: 24,
    users: __spreadArray([], Array(24), true).map(function () {
        return {
            id: 1,
            name: "test",
            mail: "k.matsuzaki@hassyadai.com",
            roles: ["admin"],
            companyName: "test",
            isDefaultRepresentative: true,
            isDeleted: false,
            createdAt: "2021-09-01 00:00:00",
            updatedAt: "2021-09-01 00:00:00",
        };
    }),
};
// mock dataが型通りの定義ではなかったので追加した。
exports.mockCorrectUsers = {
    total: 24,
    searchedTotal: 12,
    users: __spreadArray([], Array(24), true).map(function () {
        return {
            id: 1,
            name: "test",
            mail: "k.matsuzaki@hassyadai.com",
            roles: ["admin"],
            companyName: "test",
            isDefaultRepresentative: true,
            isVerified: true,
            isDeleted: false,
            createdAt: "2021-09-01 00:00:00",
            updatedAt: "2021-09-01 00:00:00",
        };
    }),
};
exports.mockUsers = {
    total: 2,
    searchedTotal: null,
    users: [
        {
            id: 1,
            name: "hoge",
            mail: "k.matsuzaki@hassyadai.com",
            roles: ["Administrator"],
            companyName: "test",
            isDefaultRepresentative: true,
            isDeleted: false,
            createdAt: "2021-09-01 00:00:00",
            updatedAt: "2021-09-01 00:00:00",
        },
        {
            id: 2,
            name: "fuga",
            mail: "k.matsuzaki@hassyadai.com",
            roles: ["Administrator"],
            companyName: "test",
            isDefaultRepresentative: true,
            isDeleted: false,
            createdAt: "2021-09-01 00:00:00",
            updatedAt: "2021-09-01 00:00:00",
        },
    ],
};
exports.mockUser = {
    id: 1,
    name: "test",
    mail: "k.matsuzaki@hassyadai.com",
    roles: ["admin"],
    companyName: "test",
    isDefaultRepresentative: true,
    isDeleted: false,
    createdAt: "2021-09-01 00:00:00",
    updatedAt: "2021-09-01 00:00:00",
};
